import { IMenuRequest } from '../types';
import { createFormData } from 'src/helpers';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const updateMenu = async (menuId: string, payload: IMenuRequest) => {
  const requestBody = createFormData(payload);
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}`, {
      method: 'PUT',
      body: requestBody,
    });
    if (!res.ok) throw new Error(res.statusText);
    return res.json();
  } catch (e) {
    throw new Error('Could not update menu', { cause: e });
  }
};
